import DOMPurify from 'dompurify';

/**
 * Renders sanitized article HTML with copy protection.
 * Props:
 *   html       — raw HTML string to render
 *   className  — applied to the inner content div for article-specific styles
 *   style      — extra styles on the outer wrapper (e.g. maxHeight, overflowY)
 *   onScroll   — scroll handler forwarded to the outer wrapper
 */
export default function ArticleContentWrapper({ html, className, style, onScroll }) {
  const sanitized = DOMPurify.sanitize(html || '', {
    ADD_TAGS: ['iframe', 'figure', 'figcaption'],
    ADD_ATTR: ['allowfullscreen', 'frameborder', 'allow', 'style'],
    ALLOW_DATA_ATTR: false,
  });

  function block(e) { e.preventDefault(); }

  function blockPrintKeys(e) {
    if (e.ctrlKey && ['c', 'a', 'p', 's'].includes(e.key.toLowerCase())) {
      e.preventDefault();
    }
  }

  return (
    <div
      style={{ userSelect: 'none', WebkitUserSelect: 'none', ...style }}
      onContextMenu={block}
      onCopy={block}
      onCut={block}
      onDragStart={block}
      onKeyDown={blockPrintKeys}
      onScroll={onScroll}
      tabIndex={-1}
    >
      {/* Print notice — hidden on screen, shown when printing */}
      <div className="article-print-notice">
        Printing is not permitted for purchased articles. Visit pubsilo.com to read online.
      </div>

      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    </div>
  );
}
